export default "__VITE_ASSET__DU9TXJYC__"